var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticStyle: {
      "position": "relative",
      "overflow": "hidden"
    },
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('calendar-header', _vm._g(_vm._b({}, 'calendar-header', {
    type: _vm.type,
    value: _vm.value
  }, false), {
    input: _vm.input,
    typeChange: _vm.typeChange
  })), _c('div', {
    staticClass: "border rounded"
  }, [_c('v-sheet', {
    staticStyle: {
      "margin": "-1px"
    }
  }, [_c('v-calendar', _vm._g(_vm._b({
    attrs: {
      "category-show-all": ""
    }
  }, 'v-calendar', {
    type: _vm.type,
    value: _vm.value,
    events: _vm.events,
    categories: _vm.categories,
    dayFormat: _vm.dayFormat,
    showMonthOnFirst: false
  }, false), {
    input: _vm.input
  }))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }